const requests = document.querySelectorAll(".js-request");

if (requests) {
    requests.forEach((request) => {
        const switcher = request.querySelector(".js-request-status-switcher");

        if (switcher) {
            switcher.addEventListener("click", () => {
                request.classList.add("completed");
            });
        }
    });
}
